<script>
  import ColorPicker from "../../Common/ColorPicker.svelte";
  import LinkPicker from "../../Common/LinkPicker.svelte";
  import BlockGlobal from "./BlockGlobal.svelte";
  import { getCollapseClass } from "../../Common/tools";
  import {M} from "../../external";

  export let data,
    disable = [],
    isCollapsable = false,
    isCollapsed = false;

  function onLinkChange(result) {
    data = Object.assign({}, data, { link: result.link });
  }

  function toggleCollapse() {
    if (isCollapsable) {
      isCollapsed = !isCollapsed;
    }
  }

  if (disable.indexOf("align") === -1) {
    data.buttonStyle.position = data.buttonStyle.position || (document.body.classList.contains("rtl-website") ? 'right' : 'left');
  }

  $: if (!data.buttonStyle) data.buttonStyle = {};
</script>

<div class="col20 f-left t-center mt-15" on:click={toggleCollapse}><h4 class="t-left {getCollapseClass(isCollapsable, isCollapsed)}">{M.BUTTON}</h4></div>
{#if !isCollapsed}
  <div class="section">
    <div class="right-side none">
      <input bind:value={data.text} type="text" class="transition-border" />
    </div>
    <div class="right-side">
      <LinkPicker config={data} onComplete={onLinkChange} emailLinkPicker={true} />
    </div>
    <div class="col20 f-left color-pick-wrap-widgets">
      <ColorPicker bind:color={data.buttonStyle.backgroundColor} label={M.BUTTON_BACKGROUND_COLOR} alpha="no" />
    </div>
    {#if disable.indexOf("align") === -1}
      <div class="popup-input-wrapper input-slider-wrapper mt-5">
        <h5 class="inline">{M.ALIGNMENT}</h5>
        <select bind:value={data.buttonStyle.position}>
          <option value="left">{M.LEFT}</option>
          <option value="center">{M.CENTER}</option>
          <option value="right">{M.RIGHT}</option>
        </select>
      </div>
    {/if}
  </div>
{/if}
<BlockGlobal bind:data disable={disable} isCollapsable={true} isCollapsed={true} />
